var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 280,
    viewBox: "0 0 281 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.097 54.608C181.097 54.608 151.148 92.5437 103.229 69.9153C55.3104 47.287 7.39143 108.517 48.6549 145.787C89.9184 183.057 49.539 203.537 77.5718 226.378C109.433 252.339 137.172 199.695 162.462 211.675C218.279 238.115 259.631 227.648 250.313 197.033C233.957 143.293 213.043 139.797 229.016 111.844C244.989 83.8917 209.736 25.7712 181.097 54.608Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.792 159.528L162.426 172.231L151.156 232.616L130.855 228.826L143.872 159.07L144.491 155.746L164.792 159.528Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.787 129.148L207.788 166.676C207.767 166.786 207.725 166.891 207.664 166.985C207.603 167.079 207.524 167.16 207.432 167.223C207.339 167.286 207.235 167.33 207.126 167.354C207.016 167.377 206.903 167.378 206.793 167.357L108.449 149.015L120.024 86.9531L194.703 100.882C208.239 103.406 217.229 116.058 214.787 129.148Z",
    fill: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.029 116.555L134.084 153.792L82.4624 144.164L89.4075 106.927C91.9646 93.217 105.594 84.2578 119.849 86.9164C134.103 89.575 143.586 102.845 141.029 116.555Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.062 133.961C161.257 133.251 158.748 129.554 159.464 125.715C160.18 121.875 163.854 119.331 167.658 120.041C168.87 120.268 170.001 120.813 170.935 121.62C171.869 122.427 172.572 123.466 172.974 124.633L221.026 133.595L219.728 140.555L171.676 131.593C170.88 132.537 169.85 133.253 168.688 133.669C167.526 134.085 166.275 134.185 165.062 133.961Z",
    fill: "#418DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.317 117.241L132.55 153.522L83.9204 144.452L90.6876 108.171C93.1789 94.8138 106.085 86.015 119.514 88.5196C132.942 91.0242 141.808 103.884 139.317 117.241Z",
    fill: "#418DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.424 130.448C168.379 130.448 169.964 128.863 169.964 126.907C169.964 124.952 168.379 123.367 166.424 123.367C164.469 123.367 162.884 124.952 162.884 126.907C162.884 128.863 164.469 130.448 166.424 130.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.581 133.573L217.336 156.331C217.318 156.429 217.262 156.516 217.179 156.572C217.097 156.629 216.996 156.65 216.898 156.632L205.74 154.551C205.721 154.547 205.704 154.536 205.692 154.52C205.681 154.503 205.677 154.483 205.681 154.464L209.981 131.409C209.984 131.39 209.995 131.373 210.012 131.362C210.028 131.351 210.048 131.346 210.067 131.35L221.522 133.486C221.541 133.49 221.558 133.501 221.569 133.517C221.581 133.534 221.585 133.554 221.581 133.573Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.013 131.431C100.483 134.888 104.276 138.996 104.276 138.996C98.4966 139.406 95.3666 136.137 94.0198 134.151C92.3547 134.632 90.6433 134.936 88.9143 135.057C77.0492 135.898 66.835 128.152 66.0974 117.747C65.3597 107.341 74.3792 98.2314 86.2444 97.3906C98.1095 96.5498 108.323 104.296 109.06 114.701C109.54 121.469 105.888 127.691 100.013 131.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.134 153.815C133.597 155.175 123.771 195.69 91.9747 189.76C57.1079 183.857 82.3279 144.152 82.3279 144.152L134.134 153.815Z",
    fill: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5785 119.795C89.2078 119.795 90.5286 118.474 90.5286 116.845C90.5286 115.215 89.2078 113.895 87.5785 113.895C85.9492 113.895 84.6284 115.215 84.6284 116.845C84.6284 118.474 85.9492 119.795 87.5785 119.795Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3717 118.506C76.0108 118.506 77.3396 117.177 77.3396 115.538C77.3396 113.899 76.0108 112.57 74.3717 112.57C72.7326 112.57 71.4038 113.899 71.4038 115.538C71.4038 117.177 72.7326 118.506 74.3717 118.506Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.659 121.049C102.298 121.049 103.627 119.72 103.627 118.081C103.627 116.442 102.298 115.113 100.659 115.113C99.0202 115.113 97.6914 116.442 97.6914 118.081C97.6914 119.72 99.0202 121.049 100.659 121.049Z",
    fill: "#699CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.792 159.528L162.426 172.231L143.872 159.07L144.491 155.746L164.792 159.528Z",
    fill: "#418DF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerNoData);
export default __webpack_public_path__ + "static/media/banner-no-data.c7a5c2504f9a58509a59ccf719378ce3.svg";
export { ForwardRef as ReactComponent };